/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import "../css/settings.css";
import Swal from "sweetalert2";
import callApi from "../utils/apiCaller";

import Integration from "./Integration";

import "../css/instruction.css";
import {
  Banner,
  Button,
  ButtonGroup,
  Badge,
  Card,
  TextField,
  Modal,
  Tooltip,
  Layout,
  Link,
} from "@shopify/polaris";

import { Row, Col } from "reactstrap";
import { MobilePlusMajor } from "@shopify/polaris-icons";

import { connect } from "react-redux";
import {
  actFetchShowLoadingPage,
  actFetchListPayPalAccounts,
} from "../actions/index";
// import Step from "./Instructions/Step";
import Video from "./Instructions/Video";
import NotifyBuyer from "./Instructions/NotifyBuyer";
import Checkify from "./Instructions/Checkify";
import config from "../config/config";
import PlanTable from "./Dashboard/PlanTable";
import UserTour from "./UserTour";

class Instructions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoadingPage: false,
      loading: false,
      modalStatus: false,
      modalTitle: "New Paypal Account",
      modalType: "add",
      listPayPalAccounts: [],
      mainAccount: {},
      copyUsername: false,
      valueClentId: "",
      valueSecret: "",
      valueEmail: "",
      errClientId: "",
      errSecret: "",
      errEmail: "",
      idDelete: 0,
      idEdit: 0,
      plan: this.props.dataSettings.plan,
    };
  }

  closeModal = () => {
    this.setState({ modalStatus: false });
  };

  handleChangeClentId = (value) => {
    this.setState({ valueClentId: value });
    if (value !== "") {
      this.setState({ errClientId: "" });
    }
  };

  handleChangeSecret = (value) => {
    this.setState({ valueSecret: value });
    if (value !== "") {
      this.setState({ errSecret: "" });
    }
  };

  handleChangeEmail = (value) => {
    this.setState({ valueEmail: value });
    if (value !== "") {
      this.setState({ errEmail: "" });
    }
  };

  confirmDeleteAccount = (id) => {
    this.setState({ idDelete: id });
    Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      text: "This Paypal account will be permanently removed from our system until you add it again",
      showCancelButton: true,
      showConfirmButton: true,
    }).then((result) => {
      if (result.value) {
        this.detelePaypalAccount();
      }
    });
  };

  openModalEdit = (index) => {
    this.setState({ idEdit: this.props.listPayPalAccounts[index].id });
    this.setState({ modalType: "edit" });
    this.setState({ valueEmail: this.props.listPayPalAccounts[index].email });
    this.setState({
      valueClentId: this.props.listPayPalAccounts[index].client_id,
    });
    this.setState({
      valueSecret: this.props.listPayPalAccounts[index].secret,
    });
    this.setState({
      errEmail: "",
      errSecret: "",
      errClientId: "",
    });
    this.setState({ modalStatus: true });
  };

  setPrimaryAccount = async (index) => {
    this.props.fetchShowLoadingPage(true);
    let params = {
      action: "setPrimaryAccount",
      id: this.props.listPayPalAccounts[index].id,
    };
    callApi("get", params).then(async (res) => {
      this.props.fetchShowLoadingPage(false);
      let newListAccount = [...this.props.listPayPalAccounts];
      for (let i = 0; i < newListAccount.length; i++) {
        if (i !== index) {
          newListAccount[i].primary_account = "0";
        } else {
          newListAccount[i].primary_account = "1";
        }
      }

      this.props.fetchListPayPalAccounts(newListAccount);
      this.setState({ listPayPalAccounts: newListAccount });

      Swal.fire({
        icon: "success",
        title: "Successfully",
        text:
          res.data.dataPaypalAccount[0].email +
          " has been marked as the primary account",
        showCloseButton: false,
        showConfirmButton: false,
        timer: 3000,
      });
    });
  };

  detelePaypalAccount = async () => {
    this.props.fetchShowLoadingPage(true);
    let params = {
      action: "detelePaypalAccount",
      id: this.state.idDelete,
    };
    callApi("get", params).then(async (res) => {
      this.props.fetchShowLoadingPage(false);

      let index = this.state.listPayPalAccounts.findIndex(
        (x) => x.id === this.state.idDelete
      );
      let newListAccount = [...this.props.listPayPalAccounts];
      newListAccount.splice(index, 1);
      this.setState({ listPayPalAccounts: newListAccount });
      this.props.fetchListPayPalAccounts(newListAccount);

      Swal.fire({
        icon: "success",
        title: "Deleted successfully!",
        text: "",
        showCloseButton: false,
        showConfirmButton: false,
        timer: 3000,
      });
    });
  };

  childResponse = (err, res) => {
    console.log(res);
  };

  connectToPayPal = async () => {
    this.props.fetchShowLoadingPage(true);
    let params = {
      action: "connectToPayPal",
    };
    // if (config.checkLocalStorage) {
    //   if (
    //     localStorage.getItem(config.shop + "-click-connect-account-paypal") !==
    //     null
    //   ) {
    //     let currentClick = localStorage.getItem(
    //       config.shop + "-click-connect-account-paypal"
    //     );
    //     localStorage.setItem(
    //       config.shop + "-click-connect-account-paypal",
    //       parseInt(currentClick) + 1
    //     );
    //   } else {
    //     localStorage.setItem(config.shop + "-click-connect-account-paypal", 1);
    //   }
    //   if (
    //     localStorage.getItem(config.shop + "-click-connect-account-paypal") >= 3
    //   ) {
    //     setTimeout(() => {
    //       let params = {
    //         action: "getDataPaypayAccount",
    //       };
    //       callApi("get", params).then(async (res) => {
    //         if (res.data.dataPaypalAccount.length === 0) {
    //           window.$crisp.push([
    //             "set",
    //             "session:event",
    //             ["synctrack-add-account-error"],
    //           ]);
    //         }
    //       });
    //     }, 10000);
    //   }
    // }
    callApi("get", params).then(async (res) => {
      if (res.data.state === 1) {
        this.props.fetchShowLoadingPage(false);
        // window.top.location.href = res.data.url;
        window.open(res.data.url, "connect paypal", "width=500,height=500");
      }
    });
  };

  componentDidMount = () => {
    window.onmessage = function (e) {
      if (e.data.type === "paypalConnected") {
        let params = {
          action: "processCodePayPalReturn",
          code: e.data.code,
        };
        callApi("get", params).then(async (res) => {
          if (res.data.state === 1) {
            window.location.reload();
          }
        });
      }
    };
  };

  processCodePayPalReturn = async (code) => {
    this.props.fetchShowLoadingPage(true);
    let params = {
      action: "connectToPayPal",
    };
    callApi("get", params).then(async (res) => {
      if (res.data.state === 1) {
        this.props.fetchShowLoadingPage(false);
        // window.top.location.href = res.data.url;
        window.open(res.data.url, "connect paypal", "width=500,height=500");
      }
    });
  };

  savePaypalAccount = async () => {
    let id = 0;
    if (this.state.modalType === "edit") {
      id = this.state.idEdit;
    }
    if (validEmail(this.state.valueEmail) === false) {
      this.setState({ errEmail: "Account id is invalid!" });
    } else if (this.state.valueClentId === "") {
      this.setState({ errClientId: "Client ID is required" });
    } else if (this.state.valueSecret === "") {
      this.setState({ errSecret: "Client ID is required" });
    } else {
      this.props.fetchShowLoadingPage(true);
      let formData = new FormData();
      formData.append("email", this.state.valueEmail);
      formData.append("client_id", this.state.valueClentId);
      formData.append("secret", this.state.valueSecret);
      formData.append("id", id);
      formData.append("action", "savePaypalAccount");
      callApi("post", formData).then((res) => {
        this.props.fetchShowLoadingPage(false);
        if (res.data.state === 1) {
          this.props.fetchListPayPalAccounts(res.data.dataPaypalAccount);
          this.setState({
            listPayPalAccounts: res.data.dataPaypalAccount,
            modalStatus: false,
          });
          Swal.fire({
            icon: "success",
            title: "Successfully!",
            text: res.data.msg,
            showCloseButton: false,
            showConfirmButton: false,
            timer: 5000,
          });
        } else if (res.data.state === 0) {
          this.setState({ errClientId: res.data.msg });
          this.setState({ errSecret: res.data.msg });
        } else if (res.data.state === 2) {
          this.setState({ errEmail: res.data.msg });
        }
      });
    }
  };

  getAccountStatus = (confirm_status, payer_id) => {
    if (confirm_status === "1") {
      return (
        <Badge
          status={payer_id == null ? "critical" : "success"}
          progress="complete"
        >
          Confirmed
        </Badge>
      );
    } else if (confirm_status === "-1") {
      return (
        <Badge status="warning" progress="complete">
          Invalid Paypal Account
        </Badge>
      );
    }
  };

  addPaypalAccount = () => {
    if (
      (this.props.listPayPalAccounts.length === 1 &&
        this.props.dataSettings.plan === "free") ||
      (this.props.listPayPalAccounts.length === 1 &&
        this.props.dataSettings.plan === "basic")
    ) {
      Swal.fire({
        icon: "warning",
        title: "Note",
        text: "This function is only applicable for Plan Pro and above. Please upgrade your Plan to use it",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((result) => {});
    } else {
      if (
        this.props.listPayPalAccounts.length === 1 &&
        this.props.listPayPalAccounts[0].email == null
      ) {
        Swal.fire({
          icon: "warning",
          title: "Note",
          text: "To use multiple accounts we need you to update the Email for an account that was previously added",
          showCancelButton: true,
          showConfirmButton: true,
        }).then((result) => {
          if (result.value) {
            this.setState({ idEdit: this.props.listPayPalAccounts[0].id });
            this.setState({ modalType: "edit" });
            this.setState({
              valueEmail: "",
              errEmail: "",
              errSecret: "",
              errClientId: "",
            });
            this.setState({
              valueClentId: this.props.listPayPalAccounts[0].client_id,
            });
            this.setState({
              valueSecret: this.props.listPayPalAccounts[0].secret,
            });
            this.setState({ modalStatus: true });
          }
        });
      } else {
        this.setState({ modalType: "add" });
        this.setState({ valueEmail: "" });
        this.setState({
          valueClentId: "",
        });
        this.setState({
          valueSecret: "",
        });
        this.setState({
          errEmail: "",
          errSecret: "",
          errClientId: "",
        });
        this.setState({ modalStatus: true });
      }
    }
  };

  render() {
    const { listPayPalAccounts } = this.props;
    return (
      <div className="app_instructions_page">
        <div>
          <div className="m-2">
            <Row>
              <Col xs="12" sm="12" md="8" className="d-flex">
                <Card title="Connecting App with Paypal" sectioned>
                  {listPayPalAccounts.length === 0 ? (
                    <Banner
                      title="You are not connected to your PayPal account."
                      status="warning"
                    >
                      In order to make the app work properly, please click
                      "Connect With PayPal" below.{" "}
                      <Link
                        external
                        url="https://www.youtube.com/watch?v=939S7HqgJi4&feature=emb_title"
                      >
                        (How to get it?)
                      </Link>
                      <br />
                      <br />
                      <b>
                        Note: Disable pop-up blocking on your browser so that
                        the connecting pop-up can appear or try with incognito
                        browser
                      </b>
                    </Banner>
                  ) : (
                    <div className="pl-2">
                      <p style={{ fontSize: "16px" }}>
                        Application is connected to Paypal. Orders will
                        automatically sync tracking information to Paypal
                      </p>
                      {listPayPalAccounts.map(function (value, index) {
                        return (
                          <div
                            key={index + 1}
                            className="mt-4 pl-4 pr-4 pt-3 pb-3 paypal-account-layout"
                            style={{
                              fontSize: "16px",
                              lineHeight: "34px",
                            }}
                          >
                            {config.role !== "view" ? (
                              <div className="group-action">
                                <ButtonGroup>
                                  {value.primary_account !== "1" ? (
                                    <div className="other-button">
                                      <Tooltip content="Mark as primary Account">
                                        <Button
                                          onClick={() =>
                                            this.setPrimaryAccount(index)
                                          }
                                        >
                                          <i className="fas fa-star"></i>
                                        </Button>
                                      </Tooltip>
                                    </div>
                                  ) : null}
                                  {value.payer_id === null ? (
                                    <div className="other-button">
                                      <Tooltip content="Edit Account">
                                        <Button
                                          onClick={() =>
                                            this.openModalEdit(index)
                                          }
                                        >
                                          <i className="fas fa-edit" />
                                        </Button>
                                      </Tooltip>
                                    </div>
                                  ) : null}
                                  <div className="delete-button">
                                    <Tooltip content="Delete Account">
                                      <Button
                                        className=""
                                        onClick={() =>
                                          this.confirmDeleteAccount(value.id)
                                        }
                                      >
                                        <i className="far fa-trash-alt" />
                                      </Button>
                                    </Tooltip>
                                  </div>
                                </ButtonGroup>
                              </div>
                            ) : null}
                            {value.primary_account === "1" ? (
                              <div>
                                <Badge status="success">
                                  <strong>Primary Account</strong>
                                </Badge>
                                {this.getAccountStatus(
                                  value.confirm_status,
                                  value.payer_id
                                )}
                                <br />
                              </div>
                            ) : (
                              <div>
                                <Badge>
                                  <strong>Second account</strong>
                                </Badge>
                                {this.getAccountStatus(
                                  value.confirm_status,
                                  value.payer_id
                                )}
                                <br />
                              </div>
                            )}
                            {value.email !== null && value.email !== "" ? (
                              <div>
                                <strong>Account: </strong> {value.email}
                                <br />
                              </div>
                            ) : null}
                            <strong>
                              {value.payer_id === null
                                ? "Client Id: "
                                : "Payer Id: "}
                            </strong>{" "}
                            {value.payer_id === null
                              ? value.client_id_show
                              : value.payer_id}
                          </div>
                        );
                      }, this)}
                    </div>
                  )}
                  {config.role !== "view" ? (
                    <div className="mt-4 ml-2">
                      <button
                        className="connect-to-paypal ml-2"
                        onClick={this.connectToPayPal}
                      >
                        <svg
                          id="CWPP_SVG_PPTM"
                          className="PPTM"
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="18px"
                          height="18px"
                          viewBox="0 0 18 18"
                          focusable="false"
                        >
                          <path
                            id="Fill-8"
                            className="PPTM-btm"
                            fill="#009cde"
                            d="M13.6023044,4.67342223 C13.8196336,3.28812419 13.6008532,2.34542498 12.8514484,1.49160831 C12.0263956,0.551629995 10.5359309,0.148937623 8.62894883,0.148937623 L3.09322219,0.148937623 C2.70355347,0.148937623 2.37175455,0.43245482 2.3109822,0.817370681 L0.00598653054,15.4327457 C-0.0395473836,15.7211605 0.183405526,15.9818221 0.475294243,15.9818221 L3.89269613,15.9818221 L3.65686311,17.4774071 C3.61713431,17.7297247 3.81196867,17.957917 4.06739398,17.957917 L6.94782221,17.957917 C7.28887304,17.957917 7.57912907,17.7097715 7.63228221,17.3731061 L7.66058217,17.226722 L8.20317953,13.7860604 L8.23819166,13.5959605 C8.29134479,13.2591138 8.58160082,13.0111496 8.92247024,13.0111496 L9.35331903,13.0111496 C12.1439493,13.0111496 14.329033,11.8774436 14.9674148,8.59894727 C15.2342689,7.22906764 15.0963973,6.08556642 14.3908938,5.28163282 C14.1773742,5.03856625 13.9119713,4.83740146 13.6023044,4.67342223"
                          ></path>
                          <path
                            id="Fill-9"
                            className="PPTM-top"
                            fill="#012169"
                            d="M13.6023044,4.67384766 C13.8196336,3.28841937 13.6008532,2.34563151 12.8514484,1.49173456 C12.0263956,0.55166786 10.5359309,0.148937623 8.62894883,0.148937623 L3.09322219,0.148937623 C2.70355347,0.148937623 2.37175455,0.432481479 2.3109822,0.817433533 L0.00598653054,15.4341828 C-0.0395473836,15.7226247 0.183405526,15.9833109 0.475294243,15.9833109 L3.89269613,15.9833109 L4.75112833,10.5399219 L4.72446105,10.7106288 C4.78523341,10.3256767 5.11431118,10.0419515 5.50397989,10.0419515 L7.12832518,10.0419515 C10.3182389,10.0419515 12.815892,8.7459583 13.5457045,4.99802736 C13.5672923,4.88718584 13.5857961,4.7796097 13.6023044,4.67384766"
                            style={{ fillOpacity: "0.699999988079071" }}
                          ></path>
                          <path
                            id="Fill-10"
                            className="PPTM-top"
                            fill="#003087"
                            d="M5.67323544,4.69235148 C5.70988026,4.46069089 5.85845507,4.27111742 6.05855031,4.17515152 C6.14961814,4.13161312 6.25120775,4.10730418 6.35769543,4.10730418 L10.6968416,4.10730418 C11.2109576,4.10730418 11.6902429,4.14104644 12.128348,4.21161494 C12.2537024,4.23175145 12.3754285,4.25497193 12.4938892,4.28127638 C12.6121686,4.30739943 12.7271825,4.33678785 12.8383869,4.36944165 C12.8940797,4.38558714 12.9486841,4.40263969 13.0025629,4.42059928 C13.2177152,4.49189341 13.4179919,4.57624907 13.6023044,4.67384766 C13.8196336,3.28841937 13.6008532,2.34563151 12.8514484,1.49173456 C12.0263956,0.55166786 10.5359309,0.148937623 8.62894883,0.148937623 L3.09322219,0.148937623 C2.70355347,0.148937623 2.37175455,0.432481479 2.3109822,0.817433533 L0.00598653054,15.4341828 C-0.0395473836,15.7226247 0.183405526,15.9833109 0.475294243,15.9833109 L3.89269613,15.9833109 L5.67323544,4.69235148"
                          ></path>
                        </svg>
                        <b>
                          {this.props.listPayPalAccounts.length === 0
                            ? "Connect with PayPal"
                            : "Add PayPal Account"}
                        </b>
                      </button>
                      {this.props.listPayPalAccounts.length === 1 ? (
                        <div className="mt-5">
                          <Banner
                            title="Note: Do you regularly change your PayPal account on Shopify to reduce the spike on one account?"
                            status="info"
                          >
                            <p>
                              Please connect to the respective PayPal accounts
                              in the application so that tracking information is
                              uploaded to the correct PayPal account
                            </p>
                          </Banner>
                        </div>
                      ) : null}
                    </div>
                  ) : null}

                  <Modal
                    open={this.state.modalStatus}
                    onClose={this.closeModal}
                    title={
                      this.state.modalType === "add"
                        ? "Add new account"
                        : "Edit Account"
                    }
                    primaryAction={{
                      content: "Save",
                      onAction: this.savePaypalAccount,
                    }}
                    secondaryActions={[
                      {
                        content: "Cancel",
                        onAction: this.closeModal,
                      },
                    ]}
                  >
                    <Modal.Section>
                      <TextField
                        label="Account Id (Email)*:"
                        value={this.state.valueEmail}
                        onChange={this.handleChangeEmail}
                        error={this.state.errEmail}
                        type="email"
                      />
                      <TextField
                        label="Client ID*:"
                        value={this.state.valueClentId}
                        onChange={this.handleChangeClentId}
                        error={this.state.errClientId}
                      />
                      <TextField
                        label="Secret* :"
                        type="password"
                        value={this.state.valueSecret}
                        onChange={this.handleChangeSecret}
                        error={this.state.errSecret}
                      />
                    </Modal.Section>
                  </Modal>
                  {/* {listPayPalAccounts.length === 0 ? <Step /> : null} */}
                  {listPayPalAccounts.length > 1 ? (
                    <div className="mt-4">
                      <Banner status="info" title="Note">
                        <p>
                          - Orders that shopify returns to a Paypal account
                          (Email) will be added with tracking information to the{" "}
                          <b>respective account</b>.
                          <br /> - Orders that shopify does not return a Paypal
                          account (Email) or Paypal account (Email) that has not
                          been added to the list, tracking information will be
                          added to the <b>primary account.</b>
                        </p>
                      </Banner>
                    </div>
                  ) : null}
                </Card>
              </Col>
              <Video />
            </Row>
            <UserTour connectPayPal={this.connectToPayPal} />
            <Row>
              <Col md={12}>
                <NotifyBuyer />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Checkify />
              </Col>
            </Row>

            {config.platform !== "WOO_COMMERCE" ? (
              <Row>
                <Col md={12}>
                  <Integration />
                </Col>
              </Row>
            ) : null}
            <Row>
              <Col md={12}>
                <div className="mt-5">
                  <Card title="Pricing Table" sectioned>
                    <PlanTable />{" "}
                  </Card>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

function validEmail(email) {
  // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var re =
    /^(([^<>()\\.,;:\s@"]+(\.[^<>()\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

const mapStateToProps = (state) => {
  return {
    listPayPalAccounts: state.listPayPalAccounts,
    dataSettings: state.dataSettings,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    fetchShowLoadingPage: (showLoadingPage) => {
      dispatch(actFetchShowLoadingPage(showLoadingPage));
    },
    fetchListPayPalAccounts: (dataPaypalAccount) => {
      dispatch(actFetchListPayPalAccounts(dataPaypalAccount));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Instructions);
